
export const bgcolor = '#656565';
export const innercolor = '#8c8c8c';
export const bradius = '10px';
export const fontcolor = '#313131';
export const border = 'var(--border)';